var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1180,
    height: 600,
    viewBox: "0 0 1180 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1180,
    height: 600
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1180,
    height: 600,
    rx: 8,
    fill: "#E4E4EB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1180,
    height: 600,
    rx: 8,
    fill: "#E4E4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.01 132.366C1201.67 132.937 1193.02 130.341 1191.46 126.195C1181.22 125.444 1170.71 115.812 1161.68 111.029C1155.66 107.742 1149.25 105.283 1142.6 103.715C1135.92 102.213 1131.2 101.316 1126.49 96.5159C1122.63 92.5816 1121.72 84.5007 1115.65 86.1332C1114.41 86.476 1113.18 90.7042 1110.64 91.1123C1106.54 91.7817 1104.87 88.8268 1103.44 85.3169C1101.26 79.946 1104.58 70.1509 1096.47 68.6164C1088.92 67.1798 1084.77 75.5382 1081.84 65.3514C1081.1 62.7394 1082 59.8988 1081.3 57.352C1080.03 52.6994 1076.01 49.9242 1072.3 46.5122C1064.72 39.5741 1057.16 30.9708 1048.61 25.2896C1043.19 21.7308 1036.08 18.4167 1029.37 18.9881C1022.66 19.5595 1020.08 27.2813 1012.94 26.6283C1002.75 25.6978 992.463 13.9274 983.893 8.85026C972.953 2.32023 964.907 -6.64224 953.426 -11.9152C937.525 -19.1962 921.083 -22.6408 905.087 -30.7381C896.09 -35.0109 887.922 -40.9238 880.981 -48.1896C871.806 -57.8214 859.531 -63.2576 850.165 -72.2037C839.495 -82.4232 828.142 -95.8914 812.829 -94.3405C807.486 -93.7855 800.697 -92.1856 795.656 -94.9446C790.615 -97.7035 788.882 -104.511 785.193 -108.723C777.863 -117.081 770.882 -118.143 760.34 -118.143",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.95 115.503C1181.99 107.051 1163.24 91.6049 1150.44 71.4252C1147.26 66.2502 1144.32 60.7649 1140.22 56.2592C1124.08 38.4812 1094.2 40.9463 1077.71 23.5111C1075.1 20.7522 1072.94 17.5361 1069.76 15.4792C1063.4 11.3326 1055.3 12.7692 1047.81 12.7692C1030.94 12.7692 1015.19 4.68827 1000.11 -3.19674L960.105 -24.1745C934.663 -37.4957 908.967 -51.0782 888.137 -71.0764C884.034 -75.0271 880.186 -79.2389 875.861 -82.961C864.73 -92.7561 851.437 -99.4494 838.271 -106.061C823.96 -113.228 809.649 -120.411 794.734 -125.994",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.152 -28.2076C952.885 -30.3299 957.671 -30.6075 960.343 -30.2973C963.014 -29.9871 965.113 -27.1302 967.848 -27.1302C972.698 -27.1302 975.242 -35.5539 980.044 -36.5824C989.235 -38.5414 991.064 -33.3174 989.935 -25.1548C989.442 -21.6286 988.869 -18.5432 993.115 -17.0902C996.661 -15.8659 1003.67 -15.8985 1007.43 -16.323C1011.53 -16.7801 1015.38 -18.1351 1018.68 -15.3598C1021.39 -13.1396 1022.66 -9.17261 1025.9 -7.4748C1029.99 -5.35254 1036.06 -6.52792 1040.6 -6.52792C1046.46 -6.52792 1051.06 -6.2504 1056.23 -3.06701C1066.58 3.28345 1075.31 4.16497 1083.69 -4.78117C1092.36 -13.6532 1102.66 -20.6722 1113.99 -25.4324C1121.95 -28.877 1130.29 -30.3299 1138.15 -34.6724C1147.69 -39.7984 1156.26 -45.4469 1165.18 -51.3892C1170.27 -54.7522 1176.07 -56.9561 1181.42 -59.3559C1184.95 -60.9884 1190.13 -62.2291 1192.72 -64.9554C1196.35 -68.7918 1201.91 -68.2204 1206.35 -71.2405",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.88 -11.6887C1093.56 -3.39554 1099.67 3.37935 1106.78 8.2932C1113.88 13.207 1121.83 16.4557 1129.82 19.4759C1157.34 30.0872 1185.8 39.4741 1215.25 40.9434",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.72 -30.9986C1146.34 -23.7992 1158.77 -9.43314 1171.73 3.39837C1174.14 5.87547 1176.71 8.17744 1179.43 10.2876C1185.6 14.7909 1192.84 17.5219 1200.38 18.1991C1207.93 18.8763 1215.52 17.4752 1222.36 14.1403",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.59 236.682L1065.7 160.281C1048.98 151.857 1032.17 143.401 1016.78 132.529C993.91 116.514 974.431 95.5686 950.548 81.2188C910.287 57.0087 859.912 53.0091 822.576 24.3096C814.403 18.0407 806.866 10.5802 797.437 6.58057C788.691 2.87477 779.007 2.43399 769.721 0.507634C731.384 -7.45901 702.857 -39.6194 668.718 -59.2095C617.342 -88.5947 555.582 -88.5947 496.875 -92.6106C408.577 -98.6672 321.407 -115.662 234.317 -131.791C217.605 -134.876 197.443 -136.688 186.519 -123.4C174.004 -108.12 183.561 -83.942 198.142 -70.7187C212.724 -57.4954 231.725 -49.4961 244.064 -34.0526C261.683 -12.0301 261.556 19.1345 262.669 47.5728C263.782 76.011 269.299 108.286 292.61 123.746C321.916 143.189 364.356 125.884 393.725 145.18C399.895 149.229 405.19 154.763 411.9 157.718C425.448 163.677 440.808 157.947 455.056 154.127C491.609 144.435 530.282 147.738 564.773 163.497C584.506 172.59 602.267 185.536 619.886 198.4L801.412 331.058C818.903 343.775 839.05 357.178 859.976 352.656C867.37 351.023 874.525 347.269 882.03 348.036C887.85 348.624 893.018 351.889 897.931 355.072C929.734 375.511 962.251 396.782 988.265 423.964C999.391 435.591 1013.71 443.461 1029.3 446.523C1044.89 449.586 1061.03 447.696 1075.55 441.105C1080.65 438.787 1085.77 436.501 1090.92 434.363C1139.14 414.515 1191.72 408.532 1243 417.058",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.23 181.341L569.018 211.183C556.615 223.411 543.831 236.242 537.836 252.812C525.735 286.344 543.847 328.348 523.668 357.505C519.089 364.035 512.855 369.406 508.753 376.328C495.46 398.807 508.514 430.445 495.221 452.925C490.546 460.794 482.93 466.899 480.131 475.666C478.128 482.016 478.939 488.938 477.81 495.517C476.076 505.492 469.986 513.997 464.087 522.11C449.246 542.484 434.405 562.852 419.564 583.215C412.186 593.353 404.744 603.605 399.958 615.261C393.168 631.635 392.182 649.871 391.26 667.665C390.433 683.37 389.67 699.45 394.011 714.55C398.352 729.651 408.815 743.838 423.603 748.033",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.25 432.746C1196.31 431.81 1178.33 432.246 1160.46 434.052C1150.84 435.031 1140.92 436.517 1132.71 441.79C1125.86 446.198 1120.77 452.907 1115.82 459.47C1103.41 475.942 1090.86 492.643 1082.73 511.71C1074.61 530.778 1071.25 552.849 1077.82 572.57C1081.53 583.769 1088.19 593.63 1094.91 603.18C1112.41 628.075 1131.33 652.367 1154.58 671.745C1177.82 691.123 1205.94 705.375 1235.78 707.66",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.45 539.251C1061.86 537.423 1049.17 528.444 1037.15 519.743L991.16 486.472C975.02 474.784 958.69 462.997 940.372 455.455C922.054 447.913 901.319 444.648 882.444 450.672C866.543 455.765 853.25 466.85 840.386 477.706L804.768 507.728C799.568 512.135 794.257 516.641 790.711 522.518C787.165 528.395 785.512 535.725 784.033 542.696C775.526 582.692 767.019 622.689 761.358 663.257C759.148 679.092 757.383 694.993 754.266 710.599C750.178 730.389 744.416 749.775 737.045 768.537",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.412 608.568C731.573 619.182 689.321 632.157 647.84 647.438C624.974 655.861 602.363 664.987 579.625 673.803C575.109 675.549 570.386 677.329 565.584 676.888C560.098 676.398 555.264 673.101 550.891 669.689C521.452 646.492 501.213 613.114 493.934 575.754C488.639 548.002 490.261 517.572 475.091 493.998C460.271 470.947 432.922 460.173 413.84 440.664C389.226 415.426 380.798 378.286 362.337 348.019C341.665 314.145 308.798 289.788 274.007 271.83C239.215 253.873 201.959 241.547 165.991 226.251C158.915 223.247 151.505 219.802 147.18 213.321C142.855 206.84 142.41 198.253 142.171 190.27C141.365 162.354 140.549 134.427 139.722 106.49C139.054 83.2919 177.026 78.1822 187.282 57.5146C194.899 42.1527 191.671 22.6933 182.003 8.53941C172.335 -5.61443 157.118 -14.8054 141.217 -20.3559C130.229 -24.2087 117.89 -26.4126 107.189 -21.7926C104.125 -20.182 100.983 -18.7327 97.7753 -17.4501C88.505 -14.5605 78.8053 -19.2785 70.0598 -23.5557C37.9159 -39.2437 3.84714 -50.381 -31.214 -56.663",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.05 718.827C1088.71 702.812 1088.65 684.822 1088.41 667.419C1088.27 653.608 1088.01 639.226 1081.84 626.95C1072.76 608.861 1053.22 599.572 1036.89 588.129C1024.66 579.591 1012.91 566.775 1010.02 552.703C1009.32 549.42 1007.56 546.476 1005.03 544.353C1002.49 542.229 999.329 541.052 996.057 541.014C986.309 540.916 976.276 537.113 967.721 531.938C954.825 524.118 943.742 513.327 930.433 506.291C916.79 499.092 900.428 495.467 890.808 483.207C882.158 472.188 881.267 456.989 880.727 442.835C880.281 429.335 881.219 413.205 892.477 406.186C903.465 399.345 917.506 405.451 928.907 411.589C934.133 414.419 939.37 417.238 944.617 420.046C951.168 423.588 957.894 427.245 962.696 433.106C967.499 438.966 969.931 447.423 966.719 454.328C968.898 457.871 974.097 457.43 977.85 455.863C981.603 454.296 985.658 451.977 989.553 453.234C992.861 454.312 994.944 457.642 997.965 459.373C1006.55 464.27 1016.36 454.785 1026.19 454.149C1034.33 453.643 1041.5 459.324 1049.39 461.446C1059.93 464.287 1071.35 460.434 1080.17 453.855C1089 447.276 1095.84 438.085 1102.36 429.155",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.348 333.359C632.194 329.964 629.348 322.209 623.385 318.487C620.506 316.903 617.388 315.826 614.162 315.304L531.938 297.167C508.881 292.073 485.332 286.947 461.973 289.723C445.834 291.616 430.346 297.216 415.097 302.946C393.519 311.108 370.765 320.593 357.758 340.053",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5531 -116.674C48.8641 -87.2892 79.5213 -70.1315 109.606 -58.7693C139.691 -47.407 171.747 -39.6526 198.143 -20.9604C204.058 -16.7812 209.894 -11.7041 212.231 -4.71696C216.302 7.47788 208.765 22.5949 216.032 33.1083C217.988 35.9488 220.802 38.0058 222.647 40.9933C224.336 44.2264 225.354 47.7839 225.636 51.4413C229.293 76.5493 231.996 105.2 215.889 124.431C211.77 129.328 206.539 133.426 203.518 139.123C200.496 144.821 200.64 153.179 206.03 156.591C216.7 163.35 233.173 144.462 241.251 154.306C243.445 156.967 243.668 160.721 244.924 163.954C249.281 175.169 263.719 176.818 275.454 177.699C298.424 179.428 320.974 184.94 342.238 194.024C370.097 205.893 396 223.948 425.767 228.928C457.441 234.217 489.8 224.03 521.793 226.609C570.609 230.544 612.111 263.161 650.432 294.44C669.8 310.243 693.365 324.886 714.927 337.228C727.139 344.183 739.924 350.288 750.975 359.022C762.026 367.756 771.392 379.82 773.602 393.974C774.174 397.68 774.27 401.549 775.621 405.042C776.574 407.461 778.084 409.606 780.023 411.293C781.962 412.979 784.272 414.157 786.752 414.723C790.489 415.556 795.037 414.544 796.802 411.05C797.803 409.091 797.724 406.757 798.105 404.52C799.537 396.358 807.646 390.725 815.772 390.497C823.897 390.268 831.466 394.48 837.461 400.014C842.024 404.226 845.968 409.483 847.272 415.637C848.575 421.792 846.747 428.926 841.738 432.55C839.56 434.183 836.729 435.195 835.648 437.693C834.439 440.452 835.95 443.602 837.492 446.165C842.497 454.449 848.408 462.117 855.111 469.02C887.167 501.964 920.528 534.794 954.476 565.779C958.102 569.044 961.791 572.619 963.445 577.288C965.575 583.214 964.033 589.826 962.157 595.834C958.517 606.863 954.308 617.686 949.547 628.255C947.225 634.3 944.226 640.047 940.611 645.38C936.031 651.633 929.862 656.432 923.771 661.134C919.526 664.399 915.089 667.827 909.874 669.019C904.658 670.211 898.457 668.562 895.865 663.779C888.295 669.609 882.216 677.239 878.151 686.013C876.148 690.356 874.128 695.482 869.676 696.951C865.892 698.224 861.853 696.265 857.862 696.053C843.741 695.351 836.984 715.088 823.611 719.839",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.524 601.563L790.392 524.428",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.919 630.949L777.879 570.334L638.856 483.24L693.046 394.562L730.271 323.189C728.861 320.42 726.88 317.999 724.466 316.096C722.052 314.193 719.264 312.853 716.294 312.17C705.735 309.378 706.085 299.583 700.281 295.73C694.478 291.877 685.001 297.101 667.287 276.875",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.232 545.192L780.057 656.268L788.358 729.829",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.87 528.411L765.779 637.332",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.906 540.28L798.487 424.454",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.972 441.252L707.612 526.306L669.02 591.329L676.35 637.333L686.909 730.386",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.692 723.039L638.856 598.674C638.856 598.674 633.243 575.591 638.856 551.985C644.469 528.379 639.89 507.907 631.192 490.064C622.494 472.22 625.07 416.601 625.07 416.601L599.231 392.979L566.793 416.601L526.42 668.987L508.531 737.731L499.547 737.731L479.909 670.048L482.47 640.075L393.63 639.552",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.19 722.515C585.19 722.515 570.37 588.649 563.723 567.72C557.077 546.792 499.817 441.25 499.817 441.25L445.149 322.665L435.45 255.503L385.361 255.503C385.361 255.503 335.273 208.275 312.217 196.733C289.16 185.191 256.563 180.996 223.282 186.758L176.104 230.477",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.563 337.85L-45 398.742",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1867 481.069L75.116 481.069",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9343 185.064L56.8619 277.823L71.1252 381.095L88.4254 493.363L245.814 615.458",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0033 470.636L19.4786 283.861",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.613 432.681L10.7172 447.945L-16.3781 436.012",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.613 464.874L114.599 456.581L75.1165 180.981",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.116 542.01L157.404 425.514L152.665 403.083L120.084 197.779L120.084 172.067L124.425 83.8629",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.222 600.259L183.45 637.513L180.715 600.259L260.125 495.779L239.168 481.086L121.611 637.529L129.212 664.27L162 694.177L176.152 734.582L190.622 730.909L185.517 674.767C185.517 674.767 248.374 666.376 288.222 636.991L365.931 620.192L292.341 533.669L305.062 406.677L305.062 357.081L301.229 287.683C301.229 287.683 290.099 246.609 331.044 209.11",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.579 13.4194L266.263 249.725L281.257 368.31L365.931 620.19L391.261 667.663C391.261 667.663 422.332 690.224 431.872 719.903",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.279 640.075L482.469 640.075C482.469 640.075 420.376 613.302 413.841 591.1C413.841 591.1 370.176 558.091 368.125 528.346C368.125 528.346 344.003 530.305 332.554 520.935",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.216 578.187C330.216 578.187 377.268 550.059 391.992 538.518C406.716 526.976 401.119 495.485 413.84 479.388C426.561 463.292 431.554 459.553 431.904 455.831C432.253 452.109 431.904 429.009 431.904 429.009L474.534 386.335L502.091 406.97L566.824 416.602",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.836 461.741L627.311 476.091L638.856 483.241L632.638 493.15",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.406 408.977L798.487 468.547L787.833 528.411L754.504 498.748L664.505 441.252L625.054 416.584",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.412 402.774L761.024 401.028L747.762 373.046C747.762 373.046 718.457 363.953 700.059 353.097C681.662 342.241 617.262 288.94 617.262 288.94C617.262 288.94 604.653 294.327 585.222 291.878C565.791 289.429 561.831 279.651 533.321 281.038L599.262 392.979L608.406 387.739L655.838 298.669L684.095 245.433",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.289 312.693L599.231 324.104L779.231 456.99L798.487 468.549L830.305 485.739L904.324 561.732L796.785 672.139L764.617 641.709",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.007 401.025L638.855 594.477L566.792 722.515",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.07 619C625.07 619 591.328 604.634 576.333 600.422C561.339 596.21 538.568 593.092 538.568 593.092C538.568 593.092 486.095 578.4 465.598 570.694C445.102 562.989 391.738 566.531 375.678 549.896",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.22 608.649L292.34 533.554C292.34 533.554 286.711 514.127 260.141 495.762",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.183 481.069C239.183 481.069 219.752 459.096 210.052 434.967C200.352 410.839 186.025 363.627 186.025 363.627L180.094 364.541L160.154 223.607L164.559 74.477",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.777 168.41L40.1661 185.747C28.1589 187.461 15.9427 186.791 4.18203 183.771L-29.1148 175.217",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.627 637.498L119.4 624.209L75.116 591.331",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0296 601.663L210.037 434.951L378.588 380.197",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.607 365.16C342.015 377.208 335.782 363.07 317.384 356.997C298.987 350.925 292.34 368.294 276.233 371.429C269.475 372.751 259.171 372.963 249.487 372.767C235.687 372.363 222.169 376.822 211.181 385.403C194.31 398.839 172.558 402.969 172.558 402.969L157.404 425.53L180.731 600.208C180.731 600.208 142.091 648.71 127.621 658.668C127.621 658.668 105.042 668.3 102.657 718.32C102.657 718.32 89.3634 700.82 72.3174 693.833",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.6 444.207L378.587 49.7931L346.404 37.6963L306.635 22.5139L261.794 26.7258L75.1158 104.368L-29.1632 165.766",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7252 99.1285L40.1332 185.749L12.0679 283.863L-6.3296 537.032",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.116 180.98L63.9376 110.962L-24.7266 58.9016",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.056 154.289L354.18 99.1266",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.397 136.983L545.342 -89.4616",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.775 150.193L588.768 -56.6127",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.702 -59.1271L550.955 157.033",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.43 181.274L711.889 -32.0616",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.847 221.68L794.734 5.63367",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.678 211.95L764.077 93.3646L861.201 93.3646C861.201 93.3646 879.598 94.9971 905.723 109.69C926.315 121.297 995.071 163.04 1023.04 180.051C1030.91 184.837 1039.85 187.432 1048.99 187.577L1054.03 187.658C1062.97 187.804 1071.73 190.288 1079.47 194.874L1219.55 277.903",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.95 434.362L397.111 38.773L307.143 4.66997L261.793 26.7252",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.69 427.08L465.615 58.6068C465.615 58.6068 424.717 35.115 418.579 29.2217C418.579 29.2217 352.479 16.9778 324.541 2.97092C296.602 -11.036 216.525 -59.6357 203.915 -113.508",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.745 37.9086L1148.96 417.516",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.494 427.08L1045.86 331.758L459.127 -1.27363L437.661 33.009",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.095 300.105L942.646 385.061",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.44 268.517L890.108 350.469",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.106 237.676L837.841 312.689",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.89 318.276L840.37 215.118C840.37 215.118 854.045 199.626 855.572 188.606C857.098 177.587 863.522 160.266 881.888 162.372L904.897 125.363",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.742 52.8939L833.246 132.43",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.85 348.543L752.5 86.1827L520.043 -42.4753L492.169 -67.0445",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.35 410.397L1186.6 320.92",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.69 416.259L1177.06 378.629",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.37 290.833L1219.47 403.166",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.63 447.439L1136.35 277.822L1173.72 250.706",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.63 288.204C1153.97 305.372 1179.58 319.012 1206.7 328.706",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.01 296.074L541.78 -82.8635",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.9 13.4219L744.153 -133.879",
    stroke: "#F2F2F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.351 -25.9391L865.112 79.0801",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.36 233.352L530.824 -62.4915L383.819 -80.3348",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.91 192.912L1012.28 312.689",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.86 331.761L1088.46 252.813L1135.45 279.455",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.22 273.282L1212.49 372.686",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.817 272.124L967.833 223.655L967.833 206.873L1010.94 128.365",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.674 268.518L801.54 193.079",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.321 246.641L763.012 171.284C763.012 171.284 771.423 150.323 778.324 144.021C785.225 137.72 813.99 97.8213 820.605 76.2722",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.848 132.43L436.292 -41.4977L368.49 -62.4918",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.055 115.484L510.518 -24.7807L435.942 -62.4916L371.607 -68.7931L333.221 -74.8171L312.677 -89.4606",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.834 -99.188L423.396 -45.4949L396.428 -4.42097L341.903 134.652",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.009 -58.2969L173.575 50.8525L102.704 45.5958L87.7251 34.9682",
    stroke: "#F2F2F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.143 4.67089L318.672 -0.112343L326.908 -19.1148L404.506 -102.405",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.123 40.9277L418.579 29.1574",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.287 35.0518L441.683 26.5627L397.271 -5.71196L235.335 -111.809",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.867 4.68652C392.867 4.68652 353.83 -16.8952 332.284 -24.8619L283.897 -58.2956L276.869 -84.6117",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.88 447.93L1013.52 502.651",
    stroke: "#F2F2F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.18 427.849C1110.61 438.378 1123.33 450.035 1123.33 450.035L1134.46 458.768C1134.46 458.768 1173.23 532.329 1202.36 545.944",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.84 481.396C1099.84 481.396 1075.09 467.356 1069.22 444.174",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.61 564.033L1134.38 458.834L1156.05 434.559",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.38 458.834L1214.62 501.328",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.82 462.801C1200.82 462.801 1151.33 449.741 1153.72 434.869",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.75 466.964L1159.42 555.903L1143.32 616.779L1112.74 627.357",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.36 619.931L1175.77 583.46L1180.6 527.874",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.19 575.053L1159.42 555.903L1081.21 515.531",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.8182 630.378L29.7983 576.979",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0806 564.032L-12.1173 569.289",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0806 489.524L-16.3788 494.78",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.7671 301.591L50.9148 102.98C50.9148 102.98 96.1851 33.9413 104.056 -20.2253",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2078 24.9951L-18.9386 -17.0093",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7065 -36.3727L26.0457 9.92519L-23.0249 95.6318",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8122 131.631L-31.1983 99.1276",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.704 291.714C309.704 291.714 248.771 306.406 221.994 305.639L172.558 305.639",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.009 281.741L239.168 255.686L241.728 207.739L185.502 257.074L-29.1624 291.699",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.809 185.261L241.728 207.74",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.881 70.4783C876.974 69.8089 885.656 69.2866 892.732 73.5148C896.042 75.8301 899.101 78.5007 901.859 81.4814C905.867 85.1718 910.083 88.617 914.485 91.7988C918.238 94.6231 922.117 97.5289 926.617 98.7043C934.027 100.663 942.121 97.7412 949.404 100.125C963.222 104.614 967.722 125.837 982.112 128.318C985.038 128.808 988.075 128.4 991.017 128.824C993.184 129.147 995.268 129.91 997.146 131.067C999.024 132.225 1000.66 133.754 1001.96 135.566C1004.15 138.652 1005.49 142.668 1008.79 144.415C1012.1 146.161 1016.28 144.855 1020.1 144.937C1026.14 145.068 1031.56 148.855 1035.76 153.312C1039.96 157.768 1043.33 163.025 1047.67 167.335C1058.45 178.012 1073.88 181.734 1088.51 185.048C1098.71 187.366 1107.46 196.475 1115.33 203.511C1119.97 207.674 1124.2 212.327 1129.12 216.131C1146.74 229.795 1170.32 230.823 1191.77 236.21C1196.16 237.304 1201.31 239.394 1202.09 243.965",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.899 13.4198L844.456 113.656L833.246 132.43",
    stroke: "#F2F2F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.795 261.611L75.1166 512.087L239.009 281.74L269.984 219.819L269.984 185.063",
    stroke: "#F2F2F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.8fd92ea7902e7008aedcbc9bb8e89b91.svg";
export { ForwardRef as ReactComponent };